import { z } from 'zod';

const metricSchema = z.coerce.number().min(0);

export const aiKpisSummarySchema = z.object({
  activeClinics: metricSchema,
  callsTotal: metricSchema,
  tokensInTotal: metricSchema,
  tokensOutTotal: metricSchema,
  tokensTotal: metricSchema,
  costEstimatedUsdTotal: metricSchema,
  byokCalls: metricSchema,
  platformCalls: metricSchema,
  errorCalls: metricSchema,
});

export const aiKpisDailyPointSchema = z.object({
  date: z.string().min(10),
  callsTotal: metricSchema,
  byokCalls: metricSchema,
  platformCalls: metricSchema,
  errorCalls: metricSchema,
  tokensInTotal: metricSchema,
  tokensOutTotal: metricSchema,
  tokensTotal: metricSchema,
  costEstimatedUsdTotal: metricSchema,
});

export const aiKpisModuleSchema = z.object({
  moduleKey: z.string().min(1),
  callsTotal: metricSchema,
  tokensTotal: metricSchema,
  costEstimatedUsdTotal: metricSchema,
});

export const aiKpisProviderSchema = z.object({
  providerKey: z.string().min(1),
  callsTotal: metricSchema,
  tokensTotal: metricSchema,
  costEstimatedUsdTotal: metricSchema,
});

export const aiKpisRecentErrorSchema = z.object({
  id: z.string().uuid(),
  createdAt: z.string().min(10),
  moduleKey: z.string().min(1),
  providerKey: z.string().min(1),
  modelId: z.string().min(1),
  status: z.string().min(1),
  errorMessage: z.string().min(1),
  clinicId: z.string().uuid().nullable(),
  clinicName: z.string().min(1),
});

export const aiKpisResponseSchema = z.object({
  periodDays: z.coerce.number().int().min(1).max(90),
  rangeStart: z.string().min(10),
  rangeEnd: z.string().min(10),
  generatedAt: z.string().min(10),
  summary: aiKpisSummarySchema,
  daily: z.array(aiKpisDailyPointSchema),
  topModules: z.array(aiKpisModuleSchema),
  providers: z.array(aiKpisProviderSchema),
  recentErrors: z.array(aiKpisRecentErrorSchema),
});
